<template>
  <el-form
    :class="[
      'grid grid-cols-1 md:grid-cols-2 gap-3 my-3 demo-ruleForm tableSearch',
      columns === 5 ? 'lg:grid-cols-5' : 'lg:grid-cols-4'
    ]"
    label-position="top"
  >
    <VehicleTag
      :value="tagValue"
      v-if="searchTag"
      @tags="$emit('selectedTags', $event)"
    />
    <slot></slot>

    <el-button
      v-if="clear"
      @click="$emit('clearFilter')"
      :class="[
        'md:flex md:col-start-1 clear-table-filter justify-center items-center',
        columns === 5 ? 'lg:col-start-4' : 'lg:col-start-3'
      ]"
    >
      {{ $t('FILTER_RESET') }}
    </el-button>
    <el-form-item
      v-if="searchable"
      :class="[
        'md:col-start-2',
        columns === 5 ? 'lg:col-start-5' : 'lg:col-start-4'
      ]"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
    >
      <el-input
        :placeholder="placeholder"
        class=""
        v-model="search"
        @input="$emit('search', search)"
      ></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import VehicleTag from './vehcileTag.vue'

export default {
  props: {
    placeholder: String,
    clear: Boolean,
    loading: Boolean,
    searchTag: Boolean,
    tagValue: Array,
    searchValue: String,
    searchable: { type: Boolean, default: true },
    columns: { type: Number, default: 4 },
  },
  data() {
    return {
      search: this.searchValue || '',
    }
  },
  components: {
    VehicleTag,
  },
  watch: {
    searchValue(newVal) {
      this.search = newVal || '' // Update `search` when `searchValue` changes
    },
  },
}
</script>
